/* eslint-disable max-len */

import { RGBColor } from 'react-color';

export const DefaultImgBackgroundsPreview = [
  'https://d2nfbjsnctzi3k.cloudfront.net/background-templates/1-min.jpg',
  'https://d2nfbjsnctzi3k.cloudfront.net/background-templates/2-min.jpg',
  'https://d2nfbjsnctzi3k.cloudfront.net/background-templates/3-min.jpg',
  'https://d2nfbjsnctzi3k.cloudfront.net/background-templates/4-min.jpg',
  'https://d2nfbjsnctzi3k.cloudfront.net/background-templates/5-min.jpg',
];

export const DefaultImgBackgrounds = [
  'https://d2nfbjsnctzi3k.cloudfront.net/background-templates/1.jpg',
  'https://d2nfbjsnctzi3k.cloudfront.net/background-templates/2.jpg',
  'https://d2nfbjsnctzi3k.cloudfront.net/background-templates/3.jpg',
  'https://d2nfbjsnctzi3k.cloudfront.net/background-templates/4.jpg',
  'https://d2nfbjsnctzi3k.cloudfront.net/background-templates/5.jpg',
];

enum EColorSchemasVariants {
  single = 'single',
  doubleLight = 'doubleLight',
  doubleContrast = 'doubleContrast',
  doubleDark = 'doubleDark',
  triple = 'triple',
  quadruple = 'quadruple',
}

enum EColorSchemasNames {
  blue = 'blue',
  darkBlue = 'darkBlue',
  green = 'green',
  red = 'red',
  yellow = 'yellow',
  darkGrey = 'darkGrey',
  // deepRed = 'deepRed',
}

type TColorSchemasNames = Record<EColorSchemasNames, string>;
type TColorSchemasVariants = Record<EColorSchemasVariants, { [K in keyof TColorSchemasNames]: string[] }>;

// string[] => Light -> dark

export const soldiBgColors = ['#0073F5', '#313EA7', '#298D9B', '#FF5045', '#FFC839', '#383F51'];

const standardColorsArrays = {
  blue: ['#8FC3FF', '#5CA8FF', '#1F88FF', '#0073F5'],
  darkBlue: ['#CEFFFF', '#AAF3FF', '#46E1F7', '#00CBE8'],
  green: ['#C7FFC5', '#8EFF84', '#0CF34C', '#1EE11E'],
  red: ['#FFCBD0', '#FF9793', '#F4706C', '#FF5045'],
  // deepRed: ['#CF253F', '#CF253F', '#CF253F', '#CF253F'],
  yellow: ['#FEFAD2', '#FFF6A4', '#FDEE7A', '#FFE600'],
  darkGrey: ['#ACB0B8', '#747B8C', '#4D566C', '#2F3646'],
};

export const extendedColorScheme:TColorSchemasVariants = {
  single: {
    blue: [standardColorsArrays.blue[3]],
    darkBlue: [standardColorsArrays.darkBlue[3]],
    green: [standardColorsArrays.green[3]],
    red: [standardColorsArrays.red[3]],
    // deepRed: [standardColorsArrays.deepRed[3]],
    yellow: [standardColorsArrays.yellow[3]],
    darkGrey: [standardColorsArrays.darkGrey[3]],
  },
  doubleLight: {
    blue: [standardColorsArrays.blue[0], standardColorsArrays.blue[2]],
    darkBlue: [standardColorsArrays.darkBlue[0], standardColorsArrays.darkBlue[2]],
    green: [standardColorsArrays.green[0], standardColorsArrays.green[2]],
    red: [standardColorsArrays.red[0], standardColorsArrays.red[2]],
    yellow: [standardColorsArrays.yellow[0], standardColorsArrays.yellow[2]],
    darkGrey: [standardColorsArrays.darkGrey[0], standardColorsArrays.darkGrey[2]],
    // deepRed: [standardColorsArrays.deepRed[0], standardColorsArrays.deepRed[2]],
  },
  doubleContrast: {
    blue: [standardColorsArrays.blue[1], standardColorsArrays.blue[3]],
    darkBlue: [standardColorsArrays.darkBlue[1], standardColorsArrays.darkBlue[3]],
    green: [standardColorsArrays.green[1], standardColorsArrays.green[3]],
    red: [standardColorsArrays.red[1], standardColorsArrays.red[3]],
    yellow: [standardColorsArrays.yellow[1], standardColorsArrays.yellow[3]],
    darkGrey: [standardColorsArrays.darkGrey[1], standardColorsArrays.darkGrey[3]],
    // deepRed: [standardColorsArrays.deepRed[1], standardColorsArrays.deepRed[3]],
  },
  doubleDark: {
    blue: [standardColorsArrays.blue[2], standardColorsArrays.blue[3]],
    darkBlue: [standardColorsArrays.darkBlue[2], standardColorsArrays.darkBlue[3]],
    green: [standardColorsArrays.green[2], standardColorsArrays.green[3]],
    red: [standardColorsArrays.red[2], standardColorsArrays.red[3]],
    yellow: [standardColorsArrays.yellow[2], standardColorsArrays.yellow[3]],
    darkGrey: [standardColorsArrays.darkGrey[2], standardColorsArrays.darkGrey[3]],
    // deepRed: [standardColorsArrays.deepRed[2], standardColorsArrays.deepRed[3]],
  },
  triple: {
    blue: [standardColorsArrays.blue[1], standardColorsArrays.blue[2], standardColorsArrays.blue[3]],
    darkBlue: [standardColorsArrays.darkBlue[1], standardColorsArrays.darkBlue[2], standardColorsArrays.darkBlue[3]],
    green: [standardColorsArrays.green[1], standardColorsArrays.green[2], standardColorsArrays.green[3]],
    red: [standardColorsArrays.red[1], standardColorsArrays.red[2], standardColorsArrays.red[3]],
    yellow: [standardColorsArrays.yellow[1], standardColorsArrays.yellow[2], standardColorsArrays.yellow[3]],
    darkGrey: [standardColorsArrays.darkGrey[1], standardColorsArrays.darkGrey[2], standardColorsArrays.darkGrey[3]],
    // deepRed: [standardColorsArrays.deepRed[1], standardColorsArrays.deepRed[2], standardColorsArrays.deepRed[3]],
  },
  quadruple: { ...standardColorsArrays },
};

export const rgbaObjToString = (rgbObj: RGBColor) => `rgba(${rgbObj.r}, ${rgbObj.g}, ${rgbObj.b}, ${rgbObj.a})`;
